import { useLocalStorage } from '@vueuse/core'
import { info } from '~/utils/logging'

export const usePreferences = () => {
  const localePath = useLocalePath()
  const { links } = useNavbar()
  const route = useRoute()

  const locale = useLocalStorage('pref:language', 'en')
  const preferredLanguage = computed({
    get() {
      return locale.value
    },
    set(lang) {
      locale.value = lang
      navigateTo(localePath(route.path, lang))
    },
  })

  const startPage = useLocalStorage('pref:start-page', 'prayer')

  const startUrl = useCookie('start_url', {
    maxAge: 30 * 24 * 60 * 60, // 30 days
  })
  const updateStartUrl = () => {
    const _links = unref(links) || {}
    const _startPage = unref(startPage)
    const _locale = unref(locale)
    const { path: _path = '/' } = _links[_startPage] || {}

    const path = localePath(_path, _locale)

    startUrl.value = path
    info(`[preferences] Setting start_url to ${path}`)
  }
  watch(locale, updateStartUrl)
  watch(startPage, updateStartUrl)
  updateStartUrl()

  const { theme: colorScheme, mode: colorMode } = useColorScheme()

  const useNativeAudio = computed(() => false)

  // Readability
  const { data: readability } = useReadabilityPreference()

  return {
    preferredLanguage,
    startPage,
    colorMode,
    colorScheme,
    readability,
    useNativeAudio,
  }
}
